/**
 * Formata um valor numérico como moeda brasileira
 * @param {number} value - Valor a ser formatado
 * @returns {string} Valor formatado como moeda (ex: "R$ 1.234,56")
 */
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

/**
 * Formata uma data string para formato brasileiro
 * @param {string|Date} dateStr - String da data (ISO ou Date object)
 * @returns {string} Data formatada (ex: "15/01/2025")
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  
  let date;
  
  // Se for um objeto Date
  if (dateStr instanceof Date) {
    date = dateStr;
  }
  // Para datas ISO formato YYYY-MM-DD
  else if (typeof dateStr === 'string' && dateStr.includes('-')) {
    const [year, month, day] = dateStr.split('-').map(Number);
    date = new Date(year, month - 1, day);
  } 
  // Caso seja uma string de data qualquer
  else {
    date = new Date(dateStr);
  }
  
  // Formatar com localização brasileira
  return date.toLocaleDateString('pt-BR');
}; 